(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pixel-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pixel-product')) {
    class PixelProduct extends HTMLElement {
      connectedCallback() {
        this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
        this.hideSold = this.dataset.hideSold === 'true';
        this.fieldsets = [...this.querySelectorAll('[data-option]')];
        this.form = this.querySelector('.pp-form');
        this.btn = this.querySelector('[data-add]');

        // start: wariant z URL (?variant=) albo z Liquid
        const urlId = new URLSearchParams(location.search).get('variant');
        const start = this.byId(urlId) || this.byId(this.dataset.variantId) || this.variants[0];
        this.sel = [...start.options];

        this.fieldsets.forEach((fs) => {
          fs.addEventListener('change', (e) => {
            this.sel[+fs.dataset.option] = e.target.value;
            this.update(true);
          });
        });

        this.querySelectorAll('[data-qty]').forEach((b) => {
          b.addEventListener('click', () => {
            const i = this.querySelector('input[name="quantity"]');
            i.value = Math.max(1, (parseInt(i.value, 10) || 1) + parseInt(b.dataset.qty, 10));
          });
        });

        if (this.form) this.form.addEventListener('submit', (e) => this.submit(e));
        this.update(false);
      }

      byId(id) { return this.variants.find((v) => String(v.id) === String(id)); }

      // Wartości opcji i, dostępne przy wybranych opcjach 0..i-1
      allowed(i) {
        const pre = this.sel.slice(0, i);
        let list = this.variants.filter((v) => pre.every((o, k) => v.options[k] === o));
        const avail = list.filter((v) => v.available);
        if (this.hideSold && avail.length) list = avail;
        return [...new Set(list.map((v) => v.options[i]))];
      }

      // Czy istnieje dostępny wariant dla pre + value (do przekreślenia)
      hasStock(i, value) {
        const pre = this.sel.slice(0, i).concat(value);
        return this.variants.some((v) => v.available && pre.every((o, k) => v.options[k] === o));
      }

      update(push) {
        // 1. opcje od 2. linijki: popraw wybór, jeśli zniknął
        for (let i = 1; i < this.sel.length; i++) {
          const ok = this.allowed(i);
          if (!ok.includes(this.sel[i])) this.sel[i] = ok[0];
        }

        // 2. pokaż/ukryj wartości; 1. linijka zawsze widoczna
        this.fieldsets.forEach((fs) => {
          const i = +fs.dataset.option;
          const ok = i === 0 ? null : this.allowed(i);
          fs.querySelectorAll('.pp-val').forEach((lab) => {
            const val = lab.dataset.value;
            lab.hidden = i === 0 ? false : !ok.includes(val);
            lab.toggleAttribute('data-soldout', !this.hasStock(i, val));
            const input = lab.querySelector('input');
            input.checked = val === this.sel[i];
          });
          const out = fs.querySelector('[data-selected-label]');
          if (out) out.textContent = this.sel[i];
        });

        // 3. znajdź wariant
        const v = this.variants.find((x) => x.options.every((o, k) => o === this.sel[k])) || this.variants[0];

        // 4. zdjęcie tylko tego wariantu
        this.querySelectorAll('[data-slide]').forEach((s) => {
          s.hidden = String(s.dataset.slide) !== String(v.id);
        });

        // 5. cena
        const price = this.querySelector('[data-price]');
        const was = this.querySelector('[data-compare]');
        const badge = this.querySelector('[data-badge]');
        const onSale = v.compare > v.price;
        if (price) price.textContent = v.priceF;
        if (was) { was.textContent = v.compareF; was.hidden = !onSale; }
        if (badge) {
          badge.hidden = !onSale;
          if (onSale) badge.textContent = '-' + Math.round((v.compare - v.price) * 100 / v.compare) + '%';
        }

        // 6. formularz i przycisk
        const idInput = this.querySelector('[data-variant-input]');
        if (idInput) idInput.value = v.id;
        if (this.btn) {
          this.btn.disabled = !v.available;
          this.btn.querySelector('[data-add-label]').textContent = v.available ? this.dataset.lAdd : this.dataset.lSold;
        }

        // 7. URL
        if (push || new URLSearchParams(location.search).has('variant')) {
          const u = new URL(location.href);
          u.searchParams.set('variant', v.id);
          history.replaceState({}, '', u);
        }

        this.current = v;
        document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v, section: this } }));
      }

      async submit(e) {
        e.preventDefault();
        if (this.btn.disabled) return;
        const label = this.btn.querySelector('[data-add-label]');
        const err = this.querySelector('[data-error]');
        err.hidden = true;
        this.btn.disabled = true;
        try {
          const res = await fetch(this.dataset.cartAdd + '.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(this.form)
          });
          const data = await res.json();
          if (!res.ok) throw new Error(data.description || data.message || 'Error');
          if (this.dataset.after === 'redirect') { location.href = this.dataset.cartUrl; return; }
          label.textContent = this.dataset.lAdded;
          document.dispatchEvent(new CustomEvent('cart:item-added', { detail: data }));
          setTimeout(() => { label.textContent = this.dataset.lAdd; this.btn.disabled = !this.current.available; }, 1800);
          return;
        } catch (ex) {
          err.textContent = ex.message;
          err.hidden = false;
        }
        this.btn.disabled = !this.current.available;
      }
    }
    customElements.define('pixel-product', PixelProduct);
  }

  } catch(e) { console.error(e); }
})();
})();
